import { Box, Grid, Stack, styled } from "@mui/material";
import { Fragment, ReactNode } from "react";
import BaseSupplierInfors from "./BaseSupplierInfors";
import SupplierTabs from "./SupplierTabs";
import { SCROLL_TOP_POSITIONS } from "constants/layout";
import { SuggestProducts } from ".";
import useBreakpoints from "hooks/useBreakpoint";
import { useSupplierContext } from "..";
import FreshdiSupport from "./FreshdiSupport";
import FarmContact from "Components/sections/FarmContact";
import { SmText, TextMd, XsText, XsTextMd } from "Components";
import { useIntl } from "react-intl";
import { WarningIcon } from "Assets/icons";
import { theme } from "theme";

type Props = {
  setShowReport?: (value: boolean) => void;
};

const FreePage = (props: Props) => {
  const { setShowReport } = props;
  const { isMobile } = useBreakpoints();
  const { supplierDetail } = useSupplierContext();
  const t = useIntl();

  return (
    <Fragment>
      {/* <SupplierWallpaper wallpaper={supplierDetail.wallpaper} /> */}

      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Stack spacing={2}>
              <BaseSupplierInfors {...{ supplierDetail }} />
              {!supplierDetail?.enabled &&
                <StylesSupplierInfor>
                  <Box className="warning-icon">
                    <WarningIcon />
                    <XsTextMd>{t.formatMessage({ id: "Attention" })}:</XsTextMd>
                  </Box>
                  <XsText fontWeight={400}>{t.formatMessage({ id: "supplier_verification_notice" })}</XsText>
                </StylesSupplierInfor>
              }
              <SupplierTabs />
            </Stack>
          </Grid>

          <Grid item xs={12} md={4} paddingTop={isMobile ? '0px !important' : '16px !important'}>
            <Stack
              spacing={2}
              position="sticky"
              top={SCROLL_TOP_POSITIONS.desktopHeader + 16}
              className="SuggestedProducts"
            >
              {!isMobile && (
                // <ContactSupplier
                //   className="card"
                //   supplierId={supplierDetail?.name}
                // />
                <FarmContact supplierId={supplierDetail?.name} />
              )}
              {!supplierDetail?.enabled && <StylesBox>
                <TextMd fontSize={isMobile ? 14 : 16} >{t.formatMessage({ id: 'is_this_your_business' })}</TextMd>
                <SmText color={'#344054'} fontSize={isMobile ? 12 : 14}>{t.formatMessage({ id: 'claim_business_description' },
                  {
                    a: (chunks: ReactNode) => <span onClick={() => setShowReport && setShowReport(true)} style={{ color: '#026AA2', cursor: 'pointer' }}>{chunks}</span>
                  }
                )}</SmText>
              </StylesBox>}
              {!isMobile && <SuggestProducts className="card" />}
              <FreshdiSupport className="card" />
            </Stack>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

const StylesSupplierInfor = styled(Stack)({
  width: "100%",
  borderRadius: "8px",
  padding: "8px 10px",
  background: "#FFFBFA",
  border: "1px solid #F04438",
  color: "#D92D20",
  display: "flex",
  flexDirection: "row",
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: "4px",
  '.warning-icon': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: 'flex-start',
  }
});
const StylesBox = styled(Stack)({
  width: "100%",
  borderRadius: "8px",
  display: "flex",
  gap: "4px",
  padding: '12px',
  backgroundColor: "#FFFFFF",
  [theme.breakpoints.down("md")]: {
  }
});
export default FreePage;
